import PageShell from "../components/PageShell";
import WorkLogos from "../components/WorkLogos";
import {
  aboutParagraphs,
  aboutEducation,
  aboutExperience,
  skillIcons
} from "../data/siteData";

export default function AboutPage() {
  return (
    <PageShell pageClass="page-about">
      <div className="container narrow">
        <section className="about-section">
          <h1 className="text-center">About</h1>
          {aboutParagraphs.map((paragraph, index) => (
            <p key={paragraph} className={index === 1 ? "indented" : ""}>
              {paragraph}
            </p>
          ))}
        </section>

        <section className="education">
          <h2>Education</h2>
          <ul>
            {aboutEducation.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="experience">
          <h2>Experience</h2>
          {aboutExperience.map((item) => (
            <p key={item}>{item}</p>
          ))}
          <p className="mb-0">
            Today, I continue to balance my dual passion for design and
            filmmaking - building brands, crafting experiences, and telling
            stories that inspire.
          </p>
        </section>

        <section className="skills">
          <h2>Skills</h2>
          <div className="icons">
            <div className="icons-track">
              {skillIcons.map((item) => (
                <div className="icon-item" key={item.src}>
                  <img
                    src={item.src}
                    alt={item.alt}
                    className={item.className || ""}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <div className="container">
        <WorkLogos animated />
      </div>
    </PageShell>
  );
}
